import './App.css';
import '@stripe/stripe-js'
import Bameio from './components/Bameio';
import BameioStripe from './components/BameioStripe';
import {useState} from 'react'
// import Loading from './components/Loading';
import {
  Route,
  Routes
} from 'react-router-dom';


function App() {
  const [selected, setSelected] = useState('Choose A language');
  return (
    <> 
    <div className='container'>
          {/* <Routes>
            <Route path='/' element={<BameioStripe  selected={selected} setSelected={setSelected} />} />
            <Route path='/Bameio' element= {<Bameio selected={selected} setSelected={setSelected}/>} />
          </Routes> */}
      </div>
 {/* <Onlypage />    */}
 <Bameio selected={selected} setSelected={setSelected}/>
 {/* <Loading /> */}
    </>
  );
}

export default App;
